export default __webpack_public_path__ + "static/media/alarmClock.87ef5d06.svg";